
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	// Application Title
	'appTitle': 'プロジェクト Gemini',
	'appExit': '「ようこそ」ページに移動する',


	'widgetsListLabel': 'ウィジェット・リスト。 ウィジェットを選択し、Enter キーを押して追加してください。',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	//General
	'listSeparator': ', ',
	'pointSeparator': ':',

	'insync': '最新',
	'dirty': '非最新',
	'conflict': 'ビューの保存時に矛盾が発生しました',
	'error': 'ビューの保存時に問題が発生しました',
	'failure': 'サーバーに問い合わせできません',
	'saveFailed': 'ビューを保存できません',

	'wa_insync': '保存しました',
	'wa_conflict': 'ビューの保存時に矛盾が発生しました',
	'wa_error': 'ビューを保存できません',
	'wa_failure': 'サーバーに問い合わせできません',

	// Menu Labels
	'changeDisplay': '表示の変更',
	'changeToColumnChart': '縦棒グラフに変更',
	'changeToBubbleChart': 'バブル・チャートに変更',
	'toggleMoveHandles': '移動ハンドルの切り替え',
	'undo': '元に戻す',
	'redo': 'やり直し',
	'mode': 'モードの変更',

	'untitled': '無題',
	'remove': '削除',
	'editTitle': 'タイトルの編集',
	'edit': '編集',
	'done': '完了',

	// Data tray
	'dataTrayHandleOpenLabel': 'データ・トレイを開く',
	'dataTrayHandleCloseLabel': 'データ・トレイを閉じる',

	// Dialogs
	'dlg_loading': 'ロードしています...',
	'dlg_ok': 'OK',
	'dlg_create': '作成',
	'dlg_cancel': 'キャンセル',
	'dlg_close': '閉じる',
	'dlg_update': '更新',
	'dlg_renameBoardTitle': 'このオブジェクトの名前変更',
	'dlg_renameDatasetTitle': 'このデータ・セットの名前変更',
	'dlg_renameSceneTitle': 'このシーンの名前変更',
	'dlg_NameLabel': '名前:',
	'dlg_NewNameLabel': '新規名:',
	'dlg_DefaultNameWithDataSet': '%{name} ビュー',
	'dlg_ShareTitle': 'コンテンツの共有',
	'dlg_UnshareTitle': 'コンテンツ共有の削除',
	'dlg_ShareUser': 'ユーザー ID:',
	'dlg_NewColumnLabel': '新しい計算名',

	'dlg_new': '新規...',
	'dlg_open': '開く...',
	'dlg_makeACopy': 'コピーの作成',
	'dlg_rename': '名前変更...',
	'dlg_moreToCome': '次のその他のアクション...',

	'dlg_use': '使用',

	'dlg_RelinkDatasetTitle': 'データ・セット \'%{datasetName}\' を置換します...',

	'open_error': 'ビューを開こうとしたときに問題が発生しました。',

	// Delete Board
	'del_dialogTitle': '削除の確認',
	'del_itemMsg': '本当に \'%{name}\' を削除しますか?',
	'del_itemsMsg': '本当に %{count} 個の項目を削除しますか?',
	'del_deleteErr': '\'%{name}\' を削除できません。',

	// List Sorting
	'dlg_ascending': '昇順',
	'dlg_descending': '降順',
	'dlg_custom': 'カスタム',
	'dlg_none': 'なし',

	// Input Placeholders
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'search': '検索',

	'searchHint': 'すべてのデータを検索',
	'clearSearchResult': '検索結果のクリア',
	// Shapes and shapes categories
	// Basic shapes
	'shapesCircle': '円',
	'shapesHexagon': '六角形',
	'shapesLine': '線',
	'shapesOctagon': '八角形',
	'shapesPentagon': '五角形',
	'shapesSquare': '四角形',
	'shapesTriangle': '三角形',
	'shapesDiamond': 'ひし形',
	'shapesTitle': '形状のプロパティー', // TODO: becomes "Shape" when FF 'PropertiesV2' is enabled


	// Advanced shapes
	'shapesSquareRounded': '角丸正方形',
	'shapesStar': '星形',
	'shapesChevron': '山形',
	'shapesBadge_ribbon': 'バッジ・リボン',
	'shapesBadge': 'バッジ',
	'shapesHeart': 'ハート',
	'shapesExclamation': '感嘆符',
	'shapesTrendingup': '上昇傾向',
	'shapesTrendingdown': '下降傾向',
	'shapesX': 'X',

	// People shapes
	'shapesPeopleCat': '人',
	'shapesFemale': '女性',
	'shapesHappyface': '笑顔',
	'shapesMale': '男性',
	'shapesMan': '男',
	'shapesNeutralface': '普通の顔',
	'shapesSadface': '悲しい顔',
	'shapesShakehands': '握手',
	'shapesThumbsdown': '反対',
	'shapesThumbsup': '賛成',
	'shapesWoman': '女',

	// Weather and places
	'shapesPlacesWeatherCat': '場所と天気',
	'shapesCity': '市',
	'shapesCloud': '曇り',
	'shapesEducation': '教育',
	'shapesGovernment': '政府',
	'shapesHalfcloud': '薄曇り',
	'shapesHouse': '家',
	'shapesMoon': '月',
	'shapesRain': '雨',
	'shapesSunny': '晴れ',

	//Vehicles
	'shapesVehiclesCat': '車両',
	'shapesAirplane': '飛行機',
	'shapesCar': '乗用車',
	'shapesShip': '船',
	'shapesShoppingcart': 'ショッピング・カート',
	'shapesTrain': '列車',
	'shapesTruck': 'トラック',

	//Objects
	'shapesObjectsCat': 'オブジェクト',
	'shapesBook': 'ブック',
	'shapesBriefcase': 'ブリーフケース',
	'shapesCalendar': 'カレンダー',
	'shapesCheck': '小切手',
	'shapesClock': '時計',
	'shapesDesktop': 'デスクトップ',
	'shapesDocument': '文書',

	'shapesFood': '食べ物',
	'shapesGear': 'ギア',
	'shapesHealth': '健康',

	'shapesIdea': 'アイデア',
	'shapesMobile': 'モバイル',
	'shapesMoney_bill': 'お金 (紙幣)',
	'shapesMoney_coin': 'お金 (硬貨)',
	'shapesPiggybank': '貯金箱',
	'shapesStackofpaper': '紙束',
	'shapesStickynote1': '付箋 1',
	'shapesStickynote2': '付箋 2',
	'shapesTarget': '目標値',
	'shapesTool': 'ツール',

	'shapesUmbrella': '傘',

	'shapesBrain': '脳',
	'shapesSkull': '頭蓋骨',
	'shapesEye': '目',

	// Arrows shapes
	'shapesArrowsCat': '矢印',
	'shapesRightArrow': '右矢印',
	'shapesLeftArrow': '左矢印',
	'shapesDoubleArrow': '二重矢印',
	'shapesCurvedArrow': '曲線矢印',

	// Callouts shapes
	'shapesCalloutsCat': 'コールアウト',
	'shapesRectCallout': 'コールアウト',

	// Images
	'imagesCat': '画像',
	'imageWidgetTitle': '画像ウィジェット',
	'imgUrl': '画像 URL',
	'noImgSelected': 'イメージが選択されていません',
	'enterImgUrl': 'イメージの URL を入力します',
	'imgPasteLink': '保存するには URL を貼り付けて Enter を押します。',
	'imgResizeToFit': '画像のサイズに合わせてサイズ変更',
	'imgHeight': '高さ:',
	'imgWidth': '幅:',
	'imgTransparency': '透過性:',
	'imgMissingUrl': '画像 URL が欠落しています。',
	'imgUrlValidationError': '画像 URL が無効です。',
	'imgUrlInvalidDomainError': '画像 URL が、管理者から承認されていないドメインを指しています。 管理者から承認されているドメインは "%{domains}" です。',
	'notPositiveNumberError': '正の値のみ',

	// line shape
	'propStrokeWidth': '線の太さ',
	'propStrokeDashArray': '線のスタイル',
	'propStrokeSolidline': '実線',
	'propStrokeLineCap': 'ライン・キャップ',
	'propStrokeLineCapButt': 'バット',
	'propStrokeLineCapRound': '四捨五入',
	'propStrokeLineCapSquare': '四角形',

	// Data player widget
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'playButtonLabel': '再生',
	'dataPlayerValueListLabel': 'データ・プレイヤー値',
	// Text Widget
	'textWidgetTitle': 'テキスト・ウィジェット',
	'textStyle': 'スタイル',
	'textStyleDescription': '事前フォーマット済みテキスト・スタイル',
	'textTitleStyle': 'タイトル',
	'textTitleSmallStyle': 'タイトル (小)',
	'textSubtitleStyle': 'サブタイトル',
	'textBodyStyle': '本文',
	'textBodySmallStyle': '本文 (小)',
	'textCaptionStyle': 'キャプション',
	'textQuoteStyle': '引用符',
	'textQuoteSmallStyle': '引用符 (小)',
	'textResponsiveStyle': '自動サイズ',
	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': '超極細',
	'textFontFamilySubClassThin': '細い',
	'textFontFamilySubClassThinItalic': '極細の斜体',
	'textFontFamilySubClassExtraLight': '細字',
	'textFontFamilySubClassExtraLightItalic': '細字の斜体',
	'textFontFamilySubClassLight': '明るい',
	'textFontFamilySubClassLightItalic': '中細の斜体',
	'textFontFamilySubClassRegular': '標準',
	'textFontFamilySubClassRegularItalic': '標準の斜体',
	'textFontFamilySubClassItalic': '斜体',
	'textFontFamilySubClassMedium': '標準の書式',
	'textFontFamilySubClassMediumItalic': '中字の斜体',
	'textFontFamilySubClassHeavy': '超極太',
	'textFontFamilySubClassHeavyItalic': '超極太の斜体',
	'textFontFamilySubClassDemiBold': '中太',
	'textFontFamilySubClassDemiBoldItalic': '中太の斜体',
	'textFontFamilySubClassBold': '太字',
	'textFontFamilySubClassBoldItalic': '太字の斜体',
	'textFontFamilySubClassExtraBold': '極太',
	'textFontFamilySubClassExtraBoldItalic': '極太の斜体',
	'textFontFamilySubClassBlack': '黒',
	'textFontFamilySubClassBlackItalic': '黒の斜体',
	'textFontFamilySubClassStencil': 'ステンシル',
	// END: Remove FontFamilySubClass

	'responsiveCoachmarkTitle': '自動サイズ・フォント',
	'responsiveCoachmarkContents': 'フォント・サイズは、このテキスト・タイプをサイズ変更したときに、それに合うように自動的にサイズ変更されます。 フォント・サイズは、テキスト・プロパティーに設定できます。',

	'propText': 'テキストの詳細', // TODO: no longer needed when FF 'PropertiesV2' is enabled, replaced with 'Details'
	'propTextReturn': 'テキスト・プロパティー', // TODO: becomes "Text" when FF 'PropertiesV2' is enabled

	'textFontSize': 'フォント・サイズ',
	'textFontFamily': 'フォント・ファミリー',
	'textFontWeight': 'フォント幅', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'textFontColor': '色',
	'textLineHeight': '行の高さ',
	'textIndentation': 'インデント',
	'textIncreaseIndentation': 'インデント拡張',
	'textDecreaseIndentation': 'インデント解除',
	'textInnerMargins': '内部マージン (px)',

	// Widget Properties
	'propImageLink': '画像リンク',
	'propMissingURL': 'URL を入力します',
	'propImgTop': '画像プロパティー', // TODO: becomes "Image" when FF 'PropertiesV2' is enabled
	'propGeneralReturn': '一般プロパティー', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyle': '全般', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propStyleReturn': '全般', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propFillColor': '塗りつぶし色', // TODO: becomes "Background color" when FF 'PropertiesV2' is enabled
	'propTextColor': 'テキストの色', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propBorderColor': '罫線の色',
	'propBorderRadius': '角の丸み (px)',
	'propShowBorderInPreview': '選択されたボーダーをプレビューに表示',
	'propMaintainAxisScales': '軸スケールを維持',
	'propShowItemLabel': '項目ラベルを表示',
	'propHideLegend': '凡例を非表示にする',
	'propColorPalette': 'パレット',
	'propLegendPosition': '凡例の位置',
	'propHideAxisTitleLabels': '軸タイトルを非表示にする',
	'propLineColor': '線の色',
	'propBubbleColor': 'バブルの色',
	'propInterpolation': '曲線',
	'propElementColor': '視覚化要素の色',
	'propSymbolShape': 'シンボルの形状',
	'propHeatScalePalette': '色の順序',
	'propHeatScalePalette_tooltipDarkerForLowerValue': '暗い色は小さい値を表します。',
	'propHeatScalePalette_tooltipDarkerForHigherValue': '暗い色は大きい値を表します。',
	'propImageDetails': '画像の詳細', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propWebDetails': 'Web ページの詳細', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propMediaDetails': 'メディアの詳細', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPasteLink': 'URL を入力して Enter を押してください。',

	//Layout Properties
	'sectionName_positionAndStyle': '位置とスタイル',
	'propPositionLabel': '位置', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propPositionXAxis_v1': 'X',
	'propPositionXAxis': 'X 位置(%{unit})',
	'propPositionYAxis_v1': 'Y',
	'propPositionYAxis': 'Y 位置(%{unit})',
	'propResizeLabel': 'サイズ', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'propResizeWidth_v1': '幅',
	'propResizeWidth': '幅(%{unit})',
	'propResizeHeight_v1': '高さ',
	'propResizeHeight': '高さ(%{unit})',
	'propRotateLabel_v1': '回転 (Rotate)',
	'propRotateLabel': '回転(°)',
	'propRotateAngle': '角度', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'propScaleLabel': 'アイコン数',
	'propScaleDescription': 'アイコン数の選択',
	'propScaleFew': '最小',
	'propScaleDefault': 'デフォルト',
	'propScaleMany': '最大',

	/* PropertyV2 controls */
	// InputLabel - number
	'propInputLabel_number_invalid': 'この値は数値でなければなりません',

	'mediaAriaLabel': 'URL の入力',
	'dropdownAriaLabel' : 'ドロップダウン',
	'ariaGroupLabel': 'ドロップダウン・リスト・カテゴリー: %{cateoryLabel} アイテム: %{itemLabel}。展開するには DOWN キーを押します。 ナビゲートするには UP キーと DOWN キーを押します。折りたたむには ESCAPE キーを押します。',
	'colorNoFillLabel': '塗りつぶしなし',
	// Timer
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'lastRefresh': '最後の最新表示: %{timeInterval} 前',
	'widgetTimer': 'ウィジェット・タイマー',

	// Theme colors
	'transparent': '色なし',
	'white': '白',
	'lightGrey': '薄いグレー',
	'grey': 'グレー',
	'darkGrey': '濃いグレー',
	'black': '黒',
	'lightBlue': '薄い青',
	'blue': '青',
	'darkBlue': '濃い青',
	'yellow': '黄',
	'orange': 'オレンジ',
	'lime': 'ライム',
	'green': '緑',
	'peach': 'ピーチ',
	'red': '赤',
	'violet': 'すみれ色',
	'aqua': '水色',
	'purple': '紫',
	'plum': 'プラム',
	'gray10': 'グレー 10',
	'gray20': 'グレー 20',
	'gray30': 'グレー 30',
	'gray50': 'グレー 50',
	'gray60': 'グレー 60',
	'gray70': 'グレー 70',
	'gray80': 'グレー 80',
	'gray90': 'グレー 90',
	'gray100': 'グレー 100',
	'blue50': '青 50',
	'blue60': '青 60',
	'blue70': '青 70',
	'green40': '緑 40',
	'green50': '緑 50',
	'red50': '赤 50',
	'red60': '赤 60',


	//Theme Palette Labels
	'themeLabel': 'テーマ',
	'paletteLabel': 'IBM パレット %{number}',
	'heatPaletteLabel': 'IBM 熱パレット %{number}',
	'conditionalPaletteLabel': 'IBM 条件付きパレット %{number}',
	'carbonPaletteXLight': 'カーボン X ライト',
	'carbonPaletteXDark': 'カーボン X ダーク',
	'carbonPalettePurple': '紫',
	'carbonPaletteTeal': '青緑',
	'carbonPaletteCyan': 'シアン',
	'carbonPaletteMagenta': 'マゼンタ',
	'carbonPalettePurpleTeal': '紫 青緑',
	'carbonPaletteCyanMagenta': 'シアン マゼンタ',
	'carbonPaletteGreenRed': '緑 赤',
	'carbonPaletteGreenYellowRed': '緑 黄 赤',
	'carbonPalettePurpleTealConvergent': '紫 青緑 コンバージェント',
	'carbonPaletteCyanMagentaConvergent': 'シアン マゼンタ コンバージェント',

	// TODO: Remove the following strings when the colour palette UI is removed
	'userPaletteColor_lightTheme': 'IBM ライト・パレット',
	'userPaletteColor_defaultTheme': 'IBM デフォルト・パレット',
	'userPaletteColor_darkTheme': 'IBM ダーク・パレット',

	// Dashboard
	'propDashboardBackgroundColor': '背景色',
	'propLayoutPositioning': 'レイアウトの位置決め',
	'propLayoutRelative': '相対',
	'propLayoutAbsolute': '絶対値',
	'propLayoutPositioningCoachmarkTitle': 'レイアウト・スタイルの選択',
	'propLayoutPositioningCoachmarkContent': '相対レイアウトでは、ウィジェットのサイズと位置が画面に合わせて調整されます。 絶対レイアウトのウィジェットは、画面サイズに関係なく、このビューで指定したとおりのサイズおよび位置で表示されます。',
	'gridText': 'グリッドの表示',
	'snapText': 'グリッドに合わせる',
	'snapObjectsText': 'オブジェクトに合わせる',
	'fitPageText': 'ページに合わせる',
	'gridLabel': 'グリッド',
	'heightUnit': 'h',
	'widthUnit': 'w',
	'pixelUnit': 'px',
	'propPageSizeLabel': 'ページ・サイズ',
	'propPageSizePresetAriaLabel': 'ページ・サイズの事前設定',
	'propPageSizePreset_v1': '事前設定',
	'propPageSizePreset': 'ページ・サイズ',
	'propPageSizePresetCustom': 'カスタム',
	'propPageSizePreset16x9': '画面 16:9',
	'propPageSizePreset4x3': '画面 4:3',
	'propPageSizePresetInfographic': '解説画像',
	'propPageSizeWidth_v1': '幅',
	'propPageSizeWidth': '幅 (px)',
	'propPageSizeHeight_v1': '高さ',
	'propPageSizeHeight': '高さ (px)',
	'propPageSizeWidthAriaLabel': 'ページ・サイズの幅',
	'propPageSizeHeightAriaLabel': 'ページ・サイズの高さ',
	'propPageSizeAdjustedMessage': 'エントリーが最小値よりも小さいか、ダッシュボードに適合しないため、ページ・サイズが拡大されました。',
	'propTabShow': 'タブの表示',
	'propShowTabsInPreview': 'プレビューにタブを表示',
	'multilingualDashboardsLabel': '言語',
	'multilingualDashboardsDefault': '%{defaultLanguage} -- デフォルト',
	'multilingualDashboardsAddLinkText': '別の言語の追加',
	'multilingualDashboardsSelect': '選択',
	'multilingualDashboardsButtonLabel': '追加',
	'multilingualDashboardTranslationMode': '現在翻訳モードです (%{currentLanguage})',
	'multilingualDashboardTranslationDone': '完了',
	'multilingualDashboardRemainingStrings': '%{numTranslationsLeft} 個の翻訳が残っています',
	'multilingualDashboardRemainingString': '1 つの翻訳が残っています',
	'multilingualDashboardsSetDefault': 'デフォルト言語の設定',
	'multilingualDashboardIconMore': '言語 %{currentLanguage} に対するその他の操作',
	'multilingualDashboardIconTranslatableArea': '翻訳可能領域',
	'multilingualDeleteTitle': '言語の削除',
	'multilingualDeleteLanguageWarning': '言語 \'%{language}\' を削除しますか?',
	'multilingualSelectLanguage': '言語の選択',
	'confirmLayoutStyleUpgradeTitle': 'すべてのタブに適用',
	'confirmLayoutStyleUpgrade': 'このレイアウト・スタイルをダッシュボード内のすべてのタブに適用しますか?',
	'defaultBackgroundColorLabel': 'デフォルト',

	//Tabs
	'tabDeleteDialogPrimaryButton': '削除',
	'tabDeleteDialogTitle': 'このタブを削除しますか?',
	'tabDeleteDialogMessage': 'このタブのコンテンツもすべて削除されます。',

	// Vis widget
	'propVisTypeReturn': '視覚化タイプ',
	'propVisDetails': '詳細',

	// Alignment picker
	'propAlignPickTop': '上揃え',
	'propAlignPickRight': '右揃え',
	'propAlignPickBottom': '下揃え',
	'propAlignPickLeft': '左揃え',
	'propAlignPickCenter': '中央揃え',
	'propAlignPickMiddle': '中央揃え',
	'propAlignPicker': '水平配置',
	'propVerticalAlignPicker': '垂直配置',

	// Toolbar picker
	'propToolbarPickBold': '太字',
	'propToolbarPickUnderline': '下線',
	'propToolbarPickItalic': '斜体',
	'propToolbarPickJustifyLeft': '左揃え',
	'propToolbarPickJustifyCenter': '中央揃え',
	'propToolbarPickJustifyRight': '右揃え',
	'propToolbarPickJustify': '行末揃え',

	'propList': 'リスト',
	'propOrderedList': '順番付けしたリスト',
	'propUnorderedList': '順番付けのないリスト',

	// Symbol shapes
	'propCircle': '円',
	'propTriangle': '三角形',
	'propSquare': '四角形',
	'propRect': '長方形',
	'propStar': '星形',
	'propCross': '十字',
	'propPlus': '正符号',
	'propPoly': '多角形',


	// True and false selection
	'propTrue': '有効',
	'propFalse': '無効',

	// Position selection
	'propLeft': '左',
	'propRight': '右',
	'propTop': '上位',
	'propBottom': '下位',

	// Interpolation options
	'propSmooth': '曲線',
	'propStraight': '直線',

	// indentedListView
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'srILVTreeLabel': 'リスト', // screen reader label for tree role

	// widget move
	'srWidgetMoveLeft': '左へ移動', // screen reader
	'srWidgetMoveUp': '上に移動', // screen reader
	'srWidgetMoveRight': '右へ移動', // screen reader
	'srWidgetMoveDown': '下に移動', // screen reader

	// widget resize
	'srWidgetResizeBigger': 'サイズを比例的に大きくする', // screen reader
	'srWidgetResizeSmaller': 'サイズを比例的に小さくする', // screen reader
	'srWidgetResizeBiggerV': 'サイズを縦方向に大きくする', // screen reader
	'srWidgetResizeSmallerV': 'サイズを縦方向に小さくする', // screen reader
	'srWidgetResizeBiggerH': 'サイズを横方向に大きくする', // screen reader
	'srWidgetResizeSmallerH': 'サイズを横方向に小さくする', // screen reader

	// widget rotate
	'srWidgetRotateCW': '右回りに回転する', // screen reader
	'srWidgetRotateCCW': '左回りに回転する', // screen reader

	// Recommended types
	'visChange': '視覚化の変更',

	// Visualization
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'visualizationLabel': '視覚化',
	'chartLabel': '%{chartName} グラフ',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'ウィジェット内でナビゲートするには F12 を押します',
	'f10KeyDescription': 'ウィジェットのフォーカス・ビューを起動するには F10 を押します',

	'WidgetLabelWithDescripion': '%{label}. %{description}',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'summaryLabel': '%{value} の値は %{label}',

	'shapeColorLabel': '形状の色',
	'showLegendLabel': '凡例の表示',

	//Webpage
	'webpageWidgetTitle': 'Web ページ・ウィジェット',
	'webpagePasteLink': '保存するには URL を貼り付けて Enter を押します。',
	'propWebpageLink': 'Web ページ URL',
	'propWebpageTitle': 'Web ページ・タイトル',
	'propWebpageTitleDescription': 'Web ページのタイトル',
	'webpageUrl': 'Web ページ URL',
	'noWebpageSelected': 'Web ページが選択されていません',
	'enterWebpageUrl': 'ここに Web ページの URL を入力します',
	'propWebpageTop': 'Web ページのプロパティー', // TODO: becomes "Web page" when FF 'PropertiesV2' is enabled
	'webpageMissingUrl': 'Web ページ URL が欠落しています。',
	'webpageUrlValidationError': 'Web ページ URL が無効です。',
	'webpageHttpValidationError': 'HTTPS リンクを使用して Web ページにアクセスしなければなりません。',
	'webpageInvalidDomainError': 'Web ページ URL が、管理者から承認されていないドメインを指しています。 管理者から承認されているドメインは "%{domains}" です。',

	//VizState
	'vzErrorLoading': '視覚化をロードできません',
	'vzErrorLoadingMissingData': 'コンテキスト・データがないため、視覚化をロードできません',

	//Media (Video / Audio)
	'mediaWidgetTitle': 'メディア・ウィジェット',
	'mediaPasteLink': '保存するには URL を貼り付けて Enter を押します。',
	'mediaUrl': 'メディアの URL',
	'noMediaSelected': 'メディアが選択されていません',
	'enterMediaUrl': 'ここにメディアの URL を入力します',
	'videoHeight': '高さ:',
	'videoWidth': '幅:',
	'propMediaLink': 'メディアのリンク',
	'propMediaTitle': 'メディアのタイトル',
	'propMediaTitleDescription': 'メディアのタイトル',
	'propMediaTop': 'メディアのプロパティー', // TODO: becomes "Media" when FF 'PropertiesV2' is enabled
	'mediaMissingUrl': 'メディア・リンク URL が欠落しています。',
	'mediaUrlValidationError': 'メディア・ファイル URL が無効です。',
	'mediaUnknownValidationError': 'このタイプのメディアはサポートされていません。',
	'mediaHttpValidationError': 'HTTPS リンクを使用してメディア・ファイルにアクセスしなければなりません。',
	'mediaInvalidDomainError': 'メディア・ファイル URL が、管理者から承認されていないドメインを指しています。 管理者から承認されているドメインは "%{domains}" です。',

	// Properties pane
	'commonPropertiesLabel': 'プロパティー', // TODO: no longer needed when FF 'PropertiesV2' is enabled

	// Data strip
	'dataSetsLabel': 'データ・セット',
	'dataViewsLabel': 'ビュー',
	'columnQuality': 'データ品質',
	'columnProperties': 'データ・プロパティー',

	'dataQuality': 'データ品質',
	'dataQualityRowCount': '行数',
	'dataQualityDistribution': '配布',
	'dataRowLabel': 'データ',

	// Modelling UI
	'typeColumn': 'タイプ',
	'modellingColumnType': 'タイプ',
	'modellingColumnAggregation': '集計',
	'modellingColumnUsage': '使用方法',
	'modellingColumnSort': 'ソート',
	'modellingColumnFormat': 'フォーマット',
	'modellingColumnCategory': 'カテゴリー',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingLoading': 'ロードしています...',

	'modellingProcessing': '処理中...',
	'modellingImport': 'インポート',
	'modellingReimport': '再インポート',
	'modellingDatasourceTitle': 'データ・ソース',
	'modellingImportStartedTitle': 'インポートの開始',
	'modellingImportStartedText': 'データのインポートには時間がかかることがあります。(データのインポート中にビューを作成できます。)',
	'importDatasourceTitle': '接続',
	'dropHere': 'ここにドロップして新規データ・ソースを作成...',
	'browseButton': '参照',
	'errorNoData': '処理するデータがありません。',
	'errorNoFile': 'アップロードするファイルがありません。',
	'errorUploadFailed': 'アップロードできません。',
	'uploadSucceessful': 'アップロード成功',
	'del_datasourceTitle': 'データ・セットの削除',
	'del_datasourceMsg': '本当に \'%{name}\' を削除しますか?',
	'modellingFileUpdate': '更新',
	'modellingFileUpdateTitle': 'データ・セットの更新',
	'modellingFileUpdateDescription': '\'%{name}\' を更新しますか?',
	'modellingFileUpdatingTitle': '\'%{name}\' の更新中',
	'modellingUpdateStartedTitle': '更新のインポートの開始',
	'modellingUpdateStartedText': 'データの更新には時間がかかることがあります。(データの更新中にビューを作成できます。)',
	'modellingErrorImportUploadNoFile': 'アップロードするファイルがありません。',
	'modellingErrorImportUploadFailed': 'アップロードできません。',
	'modellingErrorImportUploadInvalidType': 'ファイル・タイプが無効です。',
	'modellingErrorImportUploadTableFailed': '表を取得できません。',
	'modellingIntentResultsTitle': '使用する提案されたデータ・セットの選択',
	'modellingColumnViewRelationships': '関連した表の表示',
	'modellingTableRelatedTables': '\'%{name}\' に関連した表',
	'modellingTable': '%{name} - 表',
	'modellingColumnIncludedInDataSet': '追加済み',
	'modellingDataSet': 'データ・セット',
	'modellingViewInDataSet': 'データ・セット内のビュー',
	'modellingViewRelatedTables': '関連したビュー',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'modellingRelatedTablesNoneFound': '関連した表が見つかりません',

	'modellingValidatingDataset': '検証中...',
	'datasetFinishedRefreshing': 'データ・セット %{datasetName} が更新されました。',



	// Join UI - Navigation Controller titles
	'modellingJoinTable': '結合パスの解決:',
	'modellingJoinColumns': '表の結合パスの定義: %{name}',
	'modellingJoinToTable': '表に結合: %{name}',

	// Data Quality
	'excluded': '除外',
	'metricPrefixThousand': 'K',
	'metricPrefixMillion': 'M',
	'metricPrefixBillion': 'B',
	'metricPrefixTrillion': 'T',
	'metricPrefixQuadrillion': 'Q',

	//Column Flyout
	'modellingColumnFilter': 'フィルター',
	'modellingColumnSortNone': 'ソートをクリア',
	'modellingColumnSortAsc': '昇順にソート',
	'modellingColumnSortDesc': '降順にソート',
	'modellingColumnRemove': 'この列を削除',

	// Import File Browser
	'dropboxPageTitle': '新規 Dropbox 接続',
	'sizeColumn': 'サイズ',

	//Modelling Column Property Values
	'dataType_string': '文字列',
	'dataType_date': '日付',
	'dataType_integer': '整数',
	'dataType_double': '倍精度',
	'dataType_float': '浮動小数点',
	'dataType_boolean': 'ブール値',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'defaultAggregation_count': '個数',
	'defaultAggregation_countdistinct': '重複値を除くデータの個数',
	'defaultAggregation_max': '最大値',
	'defaultAggregation_min': '最小値',
	'defaultAggregation_avg': '平均',
	'defaultAggregation_sum': '合計',
	'defaultAggregation_auto': '自動 (%{aggregationType})',

	'type_fact': 'ファクト',
	'type_attribute': '属性',

	'defaultSort_none': 'ソートしない',
	'defaultSort_asc': '昇順にソート',
	'defaultSort_desc': '降順にソート',

	'category_none': 'なし',
	'category_location': '場所',
	'category_monetary': '通貨',
	'category_time': '時間',

	// Root menu
	'rootMenuTitle': 'メインメニュー',

	'errorMessageTitle': 'エラー',
	'errorMessageDetails': '詳細: ',
	'errorMessageTitleAssetAlreadyExists': '資産は既に存在します',

	'defaultTabTitle': 'タブ %{index}',
	'tabAddBtnTitle': '新規タブの追加',
	'defaultInfographicTitle': 'インフォグラフィック',

	'unsupportedConditionalFormattingEncountered': 'いくつかの列には条件付き書式がもう適用されません。',


	// Homepage View
	'nameColumn': '名前',
	'creatorColumn': '作成者',
	'creationDateColumn': '作成日',
	'versionColumn': 'バージョン',
	'modifiedColumn': '最終変更',

	'filterBy': '項目のフィルター',
	'allFilter': 'すべての項目',
	'createdByMeFilter': '自分が作成',
	'sharedWithMeFilter': '自分と共有',
	'favoritesFilter': 'お気に入り',
	'recentsFilter': '最近追加',
	'sortBy': 'ソート基準',

	// Sort Menu
	'sortModified': '変更日時',
	'sortUpdated': '更新日時',
	'sortName': '名前',

	'viewAs': '形式を指定して表示',
	'thumbnailsView': 'サムネイルとして表示',
	'listView': 'リストとして表示',
	'createMenu': '作成',
	'newAppItem': 'ダッシュボード',
	'newDataSet': 'データ・セット',

	'menuSelectionState_a11y': '"%{item}" セレクターを "%{selectedItem}"に設定します',

	'unableToShareItem': '項目 "%{item}" を共有できません。',
	'toastFetchingContent': 'コンテンツをさらに取得しています...',
	'unableToGetData': 'コンテンツを取得できません。',
	'unableToFavorite': 'お気に入りのステータスを変更できません。',
	'hpErrorMissingRequiredOptions': '必須の初期化オプションが指定されていません',
	'unableToOpenBoard': '"%{name}" を開くことができません。',
	'unableToDuplicateBoard': '"%{name}" を複製できません。',
	'unableToCreateBoard': '"%{name}" を作成できません。',
	'unableToCreateBoardNameConflict': '同じ名前の資産が既に存在します。',

	// DataSet Detail View
	'status': 'ステータス',
	'numberOfRows': '行',
	'importWarnings': '警告',
	'lineNumbers': '線',
	'excerptFromSource': '引用',
	'reason': '理由',
	'numberOfRowsDropped': '行をドロップ',
	'oneRowDropped': '1 行をドロップしました',

	// Type Menu
	'typeMenuLabel': 'タイプ',
	'dashboardsLabel': 'ダッシュボード',
	'datasetsLabel': 'データ・セット',
	'storiesLabel': 'ストーリー',
	'allLabel': 'すべてのタイプ',

	// Board Page View App Bar
	'datasets': 'データ・セット',
	'settings': 'プロパティー',
	'add': '追加',
	'widgets': 'ウィジェット',
	'dashboardProperties': 'ダッシュボード・プロパティー',
	'searchPanel' : '検索',
	'pins': 'コレクション',
	'pinsOld': 'マイピン',
	'pinsDateFilterHeading' : '日付が固定されています',
	// For languages with more than one plural form, provide the different forms delimited by |||| in the string below.
	// See https://github.com/airbnb/polyglot.js#pluralization
	'pinCount': '%{smart_count} 個のピン |||| %{smart_count} 個のピン',
	'pinSearch': '検索',
	'pinSearchOld': 'ピンの検索',
	'pinListView': 'リスト・ビュー',
	'pinIconView': 'アイコン・ビュー',
	'pinRemove': '削除',
	'pinCreate': '作成',
	'pinDeleteError': '1 つ以上の資産をコレクションから削除できません。 後でやり直してください。',
	'pinDeleteErrorOld': '1 つ以上のピンを削除できません。 後でやり直してください。',
	'pinRetrieveError': '1 つ以上のピンを取得できません。 後でやり直してください。',
	'NoPinsCollected': 'ピン留めした視覚化はありません',
	'pinDeletedToast': 'ピンは除去されました',
	'pinRenamedToast': 'ピンが名前変更されました',
	'pinAddedToast': 'ピンがマイピンに正常に追加されました',
	'pinningToast': 'ピンの処理中...',
	'pinDateFilter': '日付フィルター',
	'pinDateFilterAll': 'すべて',
	'pinDateFilterToday': '今日',
	'pinDateFilterYesterday': '昨日',
	'pinDateFilterPastWeek': '過去 1 週間',
	'pinDateFilterPastMonth': '過去 1 カ月',
	'pinDateFilterEarlier': 'それ以前',

	// data widget contextual toolbar labels
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'toolbarActionEditTitle': 'タイトルの編集',
	'toolbarActionSort': 'ソート',
	'toolbarActionSortAscending': '昇順にソート',
	'toolbarActionSortDescending': '降順にソート',
	'toolbarActionSortAuto': '自動 (%{sortOrder})',
	'toolbarActionFormat': 'データ表示形式を設定',
	'toolbarActionFormatAbbreviation': '簡略',
	'toolbarActionFormatNone': '自動',
	'toolbarActionFilter': 'フィルター',
	'toolbarActionTopBottom': '上位または下位',
	'toolbarActionAddShape': '形状の追加',
	'toolbarActionRmvShape': '形状の削除',
	'toolbarActionToggleShapeDrop': 'インフォグラフィックの形状',
	'toolbarActionToggleShapeDropTitle': 'インフォグラフィックの作成',
	'toolbarActionToggleShapeDropText': '形状をこのフィールドにドラッグしてインフォグラフィックを作成します。',
	'toolbarActionAggregationType': '要約',
	'toolbarDeleteActionText': '列の削除',
	'toolbarActionFilterLocalKeepSelected': '維持',
	'toolbarActionFilterLocalExcludeSelected': '除外',
	'toolbarActionFilterAllKeepSelected': 'フィルター',
	'toolbarActionSimpleCalculation': '単純な計算',
	'toolbarActionDrillBack': '戻る',
	'toolbarActionDrillUp': 'ドリルアップ',
	'toolbarActionDrillDown': 'ドリルダウン',
	'toolbarActionNavigate': 'ナビゲート',
	'toolbarActionCreateFilterGroup': '接続の新規作成',
	'toolbarActionDisconnectFilterGroup': 'すべてのリンクを解除',
	'toolbarActionLinkFilterGroup': '既存の接続に追加',

	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',

	// Side bar
	'sidebarAdd': '追加',
	'sidebarMultiselect': '複数選択の切り替え',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'multiselectMsg': '%{count} 個を選択済み',

	'multiselectWithTotalMsg': '%{count} 件 (全 %{total} 件中)',
	'sidebarGoBack': '戻る',

	//DataSet pane
	'errorLoadingDataSets': 'このデータ・セットをロードできません',
	'errorLoadingDataSetMetaData': 'このデータ・セットをロードできません',
	'dataSetPaneLastUpdated': '最終更新日: %{date}',
	'dataSetPaneDateUnknown': '不明',
	'sourcePaneLabel': '選択されたソース',
	'addSourceLabel': 'ソースの追加',
	'find_label': '検索',
	'navigationPathsLabel': 'ナビゲーション・パス',

	//widgetlist
	'errorLoadingWidgetList': 'オブジェクトをロードできません。',
	'errorLoadingThemeFile': 'テーマの定義をロードできません',
	'errorLoadingLayoutFile': 'ビューをロードできません。',

	//data widget

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'dwErrorLoadingAvailableVisualizations': '使用可能な視覚化定義をロードできません',

	'dwErrorLoadingVisualizationNotFound': 'オブジェクトをロードできません。オブジェクトに視覚化定義が欠落しています。',
	'dwErrorLoadingVisualizationListNotFound': '視覚化をロードできません。',
	'dwErrorRunningQuery': 'データ・セット %{datasetName} からデータを取得できません。',
	'dwErrorGeoData': '地図に地理データを表示する際に問題が発生しました。 別の視覚化タイプを選択してください。 ',
	'dwPromptSignonCancelWarning': 'この視覚化のデータは利用不可です。 正しい資格情報を指定してください。',
	'dwErrorMissingDataset': '視覚化をロードできません。その関連データ・セット \'%{datasetName}\' が使用不可です。',
	'dwErrorRenderingVisualization': 'この視覚化をロードできません。',
	'dwErrorVisualizationTooSmall': '視覚化が小さすぎるため、内容のデータを表示できません。 視覚化を大きくするか、内容のデータを制限してください。',
	'aria_label_datatable': 'データ表',
	'aria_key_navi_datatable_desc': '各セルにナビゲートするには矢印キーを使用します。 最初の行に移動するには Control キーと Home キーを押します。最後の行に移動するには Control キーと End キーを押します。',
	'geomapUnrecognizedLocations': '認識していない場所:',
	'geomapAmbiguousLocations': 'あいまいな地域:',

	// custom widget
	'customWidget': 'カスタム・ウィジェット',
	'customWidgetsTitle': 'カスタム・ウィジェット',
	'noCustomWidgets': 'カスタム・ウィジェットなし',

	// Action names
	'toggleContextBar': 'コンテキスト・バーの切り替え',
	'delete': '削除',
	'share': '共有',
	'unshare': '共有解除',
	'rename': '名前変更',
	'close': '閉じる',
	'duplicate': '複製',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'retry': '再試行',

	'changeTemplate': 'テンプレートの変更',

	// Aggregation Types
	'sum': '合計',
	'count': '個数',
	'countdistinct': '重複値を除くデータの個数',
	'avg': '平均',
	'min': '最小値',
	'max': '最大値',
	'custom': 'カスタム',
	'calculated': '計算結果',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8

	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})', // For example, the sum of Revenue

	//simple calculation
	'percDifferenceOp': '変動率',
	//For example, Profit - Expenses
	'calculationTitle': '%{col1} %{operator} %{col2}',

	'templateWidgetPlaceholderInput': '視覚化の基準...',
	'QuickAddResultsHeader': 'データ視覚化',
	'NoQuickAddResults': '目的に合うものがありませんでした。 新規データ・セットを作成しますか?',
	'NoQuickAddResultsRetry': '一致するものが見つかりません。 異なる条件で再試行してください。',
	'templateWidgetTitle': 'テンプレート',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'nullValueLabel': '(ブランク)',

	'nullValueContent': '(値なし)',
	'nullValueText': 'Null',

	// Modelling / Data Shaping
	'textFilterControlRegionLabel': 'テキスト・フィルター - %{columnName}',

	'textFilterSelectTab': '選択',

	'textFilterConditionTab': '条件の設定',
	'textFilterItemsSelected': '(%{selected})',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'textFilterItemsNotFound': '使用可能なアイテムがありません。',

	'textFilterEquals': '等しい',
	'textFilterContains': '次を含む',
	'textFilterBeginsWith': '次の値から始まる',
	'textFilterEndsWith': '後方一致',
	'textFilterDoesNotEqual': '次の値に等しくない',
	'textFilterDoesNotContain': '次の値を含まない',
	'textFilterDoesNotBeginWith': '次の値で始まらない',
	'textFilterDoesNotEndWith': '次の値で終わらない',
	'textFilterSampleText': '例: A',

	'textFilterAndButton': 'かつ',
	'textFilterOrButton': 'または',

	'dateFilterMessage': '日付の範囲を選択してください',
	'dateRangeControlRegionLabel': '日付範囲フィルター - %{columnName}',
	'dateFilterRangeOption': '範囲オプション',
	'dateFilterDateLabel': '日付',
	'dateFilterBlank': '(ブランク)',
	'dateFilterBefore': '次の日付より前',
	'dateFilterAfter': '次の日付より後',
	'dateFilterBetween': '指定の値の間',
	'dateFilterSampleText': 'YYYY-MM-DD',
	'dateTitle': '日付',
	'dateIncludeBlankLabel': '空の日付を含める',

	'timeTitle': '時間',
	'timeFilterMessage': '時間の範囲を選択してください',
	'dateTimeFilterMessage': '日付と時刻の範囲を選択してください',

	'topbottomNumberOfResultsLabel': '結果数',
	'topbottomPercentLabel': '割合',
	'topbottomNumberOfResultsLimit': '%{lower}-%{higher} の間',
	'topbottomSelectOption': '上位または下位オプション',
	'topbottomOptionLabel': '表示',
	'searchByLabel': '次のラベルで検索',
	'searchNoMatches': '一致が見つかりません',
	'topbottomRankColumnLabel': 'ランク列を表に追加',
	'topbottomNone': 'なし',
	'topCount': '上位件数',
	'topPercent': '上位 %',
	'bottomCount': '下位件数',
	'bottomPercent': '下位 %',
	'topbottomSearchColumn': '列の検索',
	'searchColumnAriaLabel': '列を検索します。 検索する列の名前を入力してから、リストで下矢印を使用して該当列を見つけます。',
	'rankColumnLabel': 'ランク (%{columnLabel})',
	'topbottomClearLabel': 'クリア',

	'rangeFilterControlRegionLabel': '範囲フィルター - %{columnName}',

	// Slider
	'sliderRegionLabel': 'スライダー・コントロール。スライダー・ハンドルを移動するには左右の矢印キーを使用します',
	'sliderHandleLabel': 'スライダー・ハンドル',
	'a11ySliderHandleLabel': 'スライダー・ハンドル %{sliderValue}',
	'sliderInputLabel': '値',

	// Refinery - Hidden columns
	'datasetItemsUnavailable': 'この視覚化で使用されているデータ・セット項目の一部が使用不可です。',
	'datasetItemUnavailable': 'このデータ・セット項目は使用不可です',

	//Authoring topBottom
	'topOperator': '上位',
	'bottomOperator': '下位',
	//For dimension column. eg: Top 5 by Quantity. %{operator} is topOperator or bottomOperator, %{val} is a number and %{fact} is a column name.
	'topBottomFact': '%{columnLabel} 別の %{operator} %{value}',
	//For fact column. eg: Top 10. %{operator} is topOperator or bottomOperator and %{val} is a number.
	'topBottomDimension': '%{operator} %{value}',
	'topBottomTitle': 'このオブジェクトのみ',
	'deleteTopBottom': '上位または下位件数を削除',
	'editTopBottom': '上位または下位件数を編集',
	'deleteDrillState': '現在のドリル状態を削除',
	'ariaDeleteDrillStateLabel': '上位または下位件数を編集するには ENTER キーを押します。',
	'drillUpStateTitle': 'ドリルアップ',
	'drillDownStateTitle': 'ドリルダウン',
	'ariaEditTopBottomLabel': '上位または下位件数を編集するには ENTER キーを押します。',
	'ariaDeleteTopBottomLabel': '上位または下位件数を削除するには DELETE キーを押します。',

	// Authoring filtering
	'dimFilterIn': '包含: %{in}',
	'dimFilterNotIn': '除外: %{out}',
	'measureFilterBetween': '%{lowerBound} と %{upperBound} の間',
	'measureFilterNotBetween': '%{lowerBound} から %{upperBound} の範囲外',
	'gtFilter': '%{lowerBound} の後',
	'ltFilter': '%{upperBound} の前',
	'notGtFilter': '%{lowerBound} の後ではない',
	'notLtFilter': '%{upperBound} の前ではない',
	'localFilterTitle': 'このオブジェクトのみ',
	'globalFilterTitle': 'すべてのオブジェクト',
	'deleteFilter': 'フィルターの削除',
	'editFilter': 'フィルターの編集',
	'ariaEditFilterLabel': 'フィルターを編集するには ENTER キーを押します。',
	'ariaDeleteFilterLabel': 'フィルターを削除するには DELETE キーを押します。',

	// Prompts
	'ariaEditPrompt': 'プロンプト値を変更するには ENTER キーを押してください',

	'moreDataIndicator': 'データは %{threshold} アイテムの位置で切り取られました。より少ない表示にするにはフィルターを適用します。',

	// data point filtering
	'dataPointFilterTitle': 'データ・ポイント',
	'dataPointFilterIncludeSummary': '%{valueCount} データ・ポイントを含む',
	'dataPointFilterExcludeSummary': '%{valueCount} データ・ポイントを含まない',

	// DB2 connection page
	'db2Database': 'DB2 データベース (%{jdbcConnection})',
	'db2Title': 'IBM DB2 への接続',

	// Database
	'databaseConnectionMessage': 'データベース接続の詳細を指定してください:',
	'connectionString': 'データベース接続文字列',
	'databaseCredentials': '資格情報: ',
	'databaseUserName': 'ユーザー名',
	'databasePassword': 'パスワード',
	'databaseConnect': '接続',

	// Twitter Keyword page
	'twitterTitle': 'Twitter',
	'twitterKeywordMessage': '検索語を入力してください:',
	'twitterKeyword': 'キーワード',
	'twitterSearch': '検索',

	// NewConnectionView Providers
	'twitterProvider': 'Twitter',
	'dropboxProvider': 'Dropbox',
	'db2Provider': 'DB2',

	'workbookCreateFailed': 'ビューを作成できません: %{error}\n失敗した操作: %{lastOp}',

	// Expanded View, Focus View
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'widgetFiltersLabel': 'ウィジェット・フィルター',
	'missingColumn': '欠落しています: %{columnLabel}',
	'missingFiltering': '次の列 ID でフィルターが欠落しています:',
	'heatByLabel': '熱の分類',
	'evColumns': '列',
	'evLocalFilters': 'ローカル・フィルター',
	'evExpand': '展開',
	'evFilterTooltip': 'フィルター',
	'evAdd': '列の追加',

	// Navigation View
	'navigationBack': '戻る',

	// Pinning
	'contentPinFail': 'コンテンツを収集できません。 後でやり直してください。',
	'contentPinFailOld': 'コンテンツをピン留めできません。 後でやり直してください。',
	'pinRenameFail': 'ピンの名前を変更できません。 後でやり直してください。',

	// Layouts
	'dropZoneLabel': '最大化するには、ここにドロップしてください。',

	//Share
	'shareDefaultPageTitle': 'ページ %{index}',

	'nextPage': '次のページ',
	'previousPage': '前のページ',

	'assetAssembly': 'ビュー',

	'toolbar_save': '保存',
	'brgr_saveAs': '名前を付けて保存',
	'brgr_refresh': '更新',

	// Save
	'saving': '保存しています...',
	'save_success': 'ビューが保存されました。',
	'save_failure': '申し訳ありません。 ビューを保存できませんでした。 後で、再試行してください。',
	'dashboard_save_success': 'ダッシュボードが保存されました。',

	'geminiLeave': 'IBM Watson Analytics を終了しようとしています。',

	'warning': '警告',
	'missingDataSetData': 'このデータ・セットのデータは使用できません。 このデータ・セットを更新するか、または管理者に連絡して、ソースにアクセスできるようにしてください。',

	// Calculations
	'error_calculation_in_use': '選択された計算は使用中のため削除できません。',

	'resize': 'サイズ変更',
	'rotate': '回転',
	'moveHandle': 'ウィジェットの移動',
	'expandHandle': '展開',
	'panHandle': 'パン',

	//Navigation
	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'navigateTitle': 'ナビゲート先',

	// Slide out titles
	'shapeSlideoutTitle': '形状',
	'textSlideoutTitle': 'テキスト',
	'mediaSlideoutTitle': 'メディア',
	'visualizationSlideoutTitle': '視覚化',

	// Board Model Dialog Messages
	'invalidJSONResponse': '指定された JSON が無効です。 詳細についてはエラー・ログを参照してください。',

	// Widget type labels
	'shape_label': '形状',
	'image_label': '画像',
	'data_label': 'グラフ',
	'media_label': 'メディア',
	'text_label': 'テキスト',
	'embedMedia_label': 'メディア',
	'youtube_label': 'YouTube ビデオ',
	'webpage_label': 'Web ページ',

	// **** Smart names for objects ****
	// You might think that one_name is useless, but we have it in case we need to change that resource into one_name_numbered
	'one_name': '%{name}',
	'one_name_numbered': '%{name} (%{number})',
	'noExtraText_shape': '形状',
	'noExtraText_shape_numbered': '形状 (%{number})',
	'few_shape': '%{count} 個の形状のグループ',
	'many_shape': '%{count} 個の形状のグループ',
	// %{text} is the description of the image, specified in the properties by the user
	'one_image': '%{text} の画像',
	'one_image_numbered': '%{text} の画像 (%{number})',
	'noExtraText_image': '画像',
	'noExtraText_image_numbered': '画像 (%{number})',
	'few_image': '%{count} 個の画像のグループ',
	'many_image': '%{count} 個の画像のグループ',
	'noExtraText_text': '空のテキスト・ボックス',
	'noExtraText_text_numbered': '空のテキスト・ボックス (%{number})',
	'few_text': '%{count} 個のテキスト・ボックスのグループ',
	'many_text': '%{count} 個のテキスト・ボックスのグループ',
	//pa cube viewer
	'pacubeviewer_no_mapping': 'Cube Viewer',
	'pacubeviewer_named': '%{name} Cube Viewer',
	// Crosstab: values by Row1 (and Column1)
	'crosstab_opt_mapping': '%{row_level1} および %{column_level1} 別の %{values} のクロス集計',
	'crosstab_opt_mapping_numbered': '%{row_level1} および %{column_level1} 別の %{values} (%{number}) のクロス集計',
	'crosstab_has_mapping': '%{row_level1} 別の %{values} のクロス集計',
	'crosstab_has_mapping_numbered': '%{row_level1} 別の %{values} (%{number}) のクロス集計',
	'crosstab_no_mapping': '空のクロス集計',
	'crosstab_no_mapping_numbered': '空のクロス集計 (%{number})',
	'crosstab_named': '%{name} のクロス集計',
	'crosstab_named_numbered': '%{name} のクロス集計 (%{number})',
	// Grid: first column grid
	'JQGrid_has_mapping': '%{grid_cols} 表',
	'JQGrid_has_mapping_numbered': '%{grid_cols} 表 (%{number})',
	'JQGrid_no_mapping': '空の表',
	'JQGrid_no_mapping_numbered': '空の表 (%{number})',
	'JQGrid_named': '%{name} 表',
	'JQGrid_named_numbered': '%{name} 表 (%{number})',
	// Hierarchy: level one hierarchy
	'hierarchy_has_mapping': '%{level1} の階層',
	'hierarchy_has_mapping_numbered': '%{level1} の階層 (%{number})',
	'hierarchy_no_mapping': '空の階層',
	'hierarchy_no_mapping_numbered': '空の階層 (%{number})',
	'hierarchy_named': '%{name} の階層',
	'hierarchy_named_numbered': '%{name} の階層 (%{number})',
	// Legacy map: Region heat by Regions map
	'map_has_mapping': '%{categories} のマップ',
	'map_has_mapping_numbered': '%{categories} のマップ (%{number})',
	'map_no_mapping': '空のマップ',
	'map_no_mapping_numbered': '空のマップ (%{number})',
	'map_named': '%{name} のマップ',
	'map_named_numbered': '%{name} のマップ (%{number})',
	// Summary value: value summary value
	'summary_has_mapping': '%{actual} の集計値',
	'summary_has_mapping_numbered': '%{actual} の集計値 (%{number})',
	'summary_no_mapping': '空の集計値',
	'summary_no_mapping_numbered': '空の集計値 (%{number})',
	'summary_named': '%{name} の集計値',
	'summary_named_numbered': '%{name} の集計値 (%{number})',

	// KPI: actual value, optional time
	'kpi_opt_mapping': '%{sparkline.time} 別の %{actual} の KPI',
	'kpi_opt_mapping_numbered': '%{sparkline.time} 別の %{actual} の KPI (%{number})',
	'kpi_has_mapping': '%{actual} KPI',
	'kpi_has_mapping_numbered': '%{actual} KPI (%{number})',
	'kpi_no_mapping': '空の KPI',
	'kpi_no_mapping_numbered': '空の KPI (%{number})',
	'kpi_named': '%{name} KPI',
	'kpi_named_numbered': '%{name} KPI (%{number})',

	// (Infographic summary) Infographic: value infographic
	'infographicSummary_has_mapping': '%{actual} のインフォグラフィック',
	'infographicSummary_has_mapping_numbered': '%{actual} のインフォグラフィック (%{number})',
	'infographicSummary_no_mapping': '空のインフォグラフィック',
	'infographicSummary_no_mapping_numbered': '空のインフォグラフィック (%{number})',
	'infographicSummary_named': '%{name} のインフォグラフィック',
	'infographicSummary_named_numbered': '%{name} のインフォグラフィック (%{number})',
	'noExtraText_youtube': 'YouTube ビデオ',
	'noExtraText_youtube_numbered': 'YouTube ビデオ (%{number})',
	// %{text} is the user-provided title of the video
	'one_youtube': '%{text} の YouTube ビデオ',
	'one_youtube_numbered': '%{text} の YouTube ビデオ (%{number})',
	'few_youtube': '%{count} 個の YouTube ビデオのグループ',
	'many_youtube': '%{count} 個の YouTube ビデオのグループ',
	'noExtraText_embedMedia': 'メディアのリンク',
	'noExtraText_embedMedia_numbered': 'メディア・リンク (%{number})',
	// %{text} is the user-provided title of the media link
	'one_embedMedia': '%{text} のメディア・リンク',
	'one_embedMedia_numbered': '%{text} のメディア・リンク (%{number})',
	'few_embedMedia': '%{count} 個のメディア・リンクのグループ',
	'many_embedMedia': '%{count} 個のメディア・リンクのグループ',
	'noExtraText_media': 'メディア',
	'noExtraText_media_numbered': 'メディア (%{number})',
	// %{text} is the user-provided title of the media link
	'one_media': '%{text} のメディア',
	'one_media_numbered': '%{text} のメディア (%{number})',
	'few_media': '%{count} 個のメディアのグループ',
	'many_media': '%{count} 個のメディアのグループ',
	'noExtraText_webpage': 'Web ページ',
	'noExtraText_webpage_numbered': 'Web ページ (%{number})',
	// %{text} is the user-provided title of the web page
	'one_webpage': '%{text} の Web ページ',
	'one_webpage_numbered': '%{text} の Web ページ (%{number})',
	'few_webpage': '%{count} 個の Web ページのグループ',
	'many_webpage': '%{count} 個の Web ページのグループ',
	'one_unknown': 'オブジェクト',
	'one_unknown_numbered': 'オブジェクト (%{number})',
	'few_unknown': '%{count} 個のオブジェクトのグループ',
	'many_unknown': '%{count} 個のオブジェクトのグループ',

	//a11y label for the left/right arrow for navigation path

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'next': '次へ',
	'previous': '戻る',
	//a11y description

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'current_nav_group': '現在のナビゲーション・グループは %{navigation_group_name} です',

	//Page Context
	'filterBlank': '(ブランク)',

	// no longer used in this component, moved to dashboard-livewidget.
	// please don't remove from here, or will break R8
	'errMsgFilterItemGenericTitle': 'フィルター値をロードできません',
	'editTimelineHighlight': 'ハイライトの編集',

	'filterDockChevronLeft': 'データをスクロールします',
	'filterDockChevronRight': 'データをスクロールします',
	'expand': '展開',
	'collapse': '省略',

	//Reset Dashboard
	'dashboardResetTitle': 'ダッシュボードのリセット',
	'dashboardResetMessage': 'このダッシュボードに適用されたすべての変更をリセットしますか?',
	'dashboardResetToast': 'ダッシュボードはリセットされました。',

	//Generate PDF
	'buildingPDF': 'PDF の作成中...',
	'exportPDF': 'PDF にエクスポート',
	'pageSize': 'ページ・サイズ',
	'orientation': '用紙の向き',
	'filtersPresentPDF': '前のページの視覚化に適用されたフィルター:',
	'errorPDF': 'PDF を生成できません。 更新して再試行してください。',
	'errorPrintPDF': 'PDF を生成できません。 再実行してください。',
	'printPDFInfo': 'ドキュメントの表示',
	'pdfWidget': 'ウィジェット',
	'includeFilters': 'フィルター詳細の表示',
	'portrait': '縦',
	'landscape': '横',
	'letter': 'Letter',
	'legal': 'Legal',
	'a4':'A4',
	'tabloid':'Tabloid',

	'toastUpgradeDone': 'ダッシュボードがアップグレードされました。 今すぐ保存して、最適なパフォーマンスを維持してください。',

	'migratingDashboard': 'ダッシュボード・データをマイグレーションする必要があります。マイグレーションが完了するとダッシュボードが保存されます ...',
	'migrateDone': 'ダッシュボード・データがマイグレーションされました。',
	'migrateNoPermission': 'ダッシュボード・データをマイグレーションする必要があります。これには書き込み権限が必要です。視覚化はエラーでレンダリングされます。',
	'migratingDataSourcesFailed': '1 つ以上のデータ・ソースがデータ・マイグレーションに失敗しました',

	'ariaFullScreenMessage': 'Escape を押すとフルスクリーンを終了します',

	/**********************************************
	*******************LIVE WIDGET*****************
	***********************************************/
	// Hierarchy Packed Bubble
	'LIVE_hierarchy_packed_bubble_has_mapping': '%{categories} パック階層バブル・チャート',
	'LIVE_hierarchy_packed_bubble_has_mapping_numbered': '%{categories} パック階層バブル・チャート (%{number})',
	'LIVE_hierarchy_packed_bubble_no_mapping': '空のパック階層バブル・チャート',
	'LIVE_hierarchy_packed_bubble_no_mapping_numbered': '空のパック階層バブル・チャート (%{number})',
	'LIVE_hierarchy_packed_bubble_named': '%{name} パック階層バブル・チャート',
	'LIVE_hierarchy_packed_bubble_named_numbered': '%{name} パック階層バブル・チャート (%{number})',

	// Marimekko
	'LIVE_marimekko_has_mapping': '%{values} 別の %{categories} のマリメッコ・グラフ',
	'LIVE_marimekko_has_mapping_numbered': '%{values} 別の %{categories} のマリメッコ・グラフ (%{number})',
	'LIVE_marimekko_no_mapping': '空のマリメッコ・グラフ',
	'LIVE_marimekko_no_mapping_numbered': '空のマリメッコ・グラフ (%{number})',
	'LIVE_marimekko_named': '%{name} マリメッコ・グラフ',
	'LIVE_marimekko_numbered': '%{name} マリメッコ・グラフ (%{number})',

	// Sunburst
	'LIVE_sunburst_has_mapping': '%{values} サンバースト・グラフ',
	'LIVE_sunburst_has_mapping_numbered': '%{values} サンバースト・グラフ (%{number})',
	'LIVE_sunburst_no_mapping': '空のサンバースト・グラフ',
	'LIVE_sunburst_no_mapping_numbered': '空のサンバースト・グラフ (%{number})',
	'LIVE_sunburst_named': '%{name} サンバースト・グラフ',
	'LIVE_sunburst_named_numbered': '%{name} サンバースト・グラフ (%{number})',

	// Driver Analysis
	'LIVE_decision_analysis_has_mapping': '%{values} ドライバー分析グラフ',
	'LIVE_decision_analysis_has_mapping_numbered': '%{values} ドライバー分析グラフ (%{number})',
	'LIVE_decision_analysis_no_mapping': '空のドライバー分析グラフ',
	'LIVE_decision_analysis_no_mapping_numbered': '空のドライバー分析グラフ (%{number})',
	'LIVE_decision_analysis_named': '%{name} ドライバー分析グラフ',
	'LIVE_decision_analysis_named_numbered': '%{name} ドライバー分析グラフ (%{number})',

	// Line and Column
	'LIVE_line_column_opt_mapping': '%{columnValue} および %{lineValue} 別の %{categories} の折れ線グラフと縦棒グラフ',
	'LIVE_line_column_opt_mapping_numbered': '%{columnValue} および %{lineValue} 別の %{categories} の折れ線グラフと縦棒グラフ (%{number})',
	'LIVE_line_column_has_mapping': '%{columnValue} および %{lineValue} の折れ線グラフと縦棒グラフ',
	'LIVE_line_column_has_mapping_numbered': '%{columnValue} および %{lineValue} 別の %{categories} の折れ線グラフと縦棒グラフ (%{number})',
	'LIVE_line_column_no_mapping': '空の折れ線グラフと縦棒グラフ',
	'LIVE_line_column_no_mapping_numbered': '空の折れ線グラフと縦棒グラフ (%{number})',
	'LIVE_line_column_named': '%{name} の折れ線グラフと縦棒グラフ',
	'LIVE_line_column_named_numbered' : '%{name} の折れ線グラフと縦棒グラフ (%{number})',

	// Bubble chart
	'LIVE_bubble_chart_has_mapping': '%{y} および %{size} 別の %{x} のバブル・チャート',
	'LIVE_bubble_chart_has_mapping_numbered': '%{y} および %{size} 別の %{x} のバブル・チャート (%{number})',
	'LIVE_bubble_chart_no_mapping': '空のバブル・チャート',
	'LIVE_bubble_chart_no_mapping_numbered': '空のバブル・チャート (%{number})',
	'LIVE_bubble_chart_named': '%{name} のバブル・チャート',
	'LIVE_bubble_chart_named_numbered': '%{name} のバブル・チャート (%{number})',

	// Bullet chart
	'LIVE_bullet_has_mapping': '%{actual} ブレット・グラフ',
	'LIVE_bullet_has_mapping_numbered': '%{actual} ブレット・グラフ (%{number})',
	'LIVE_bullet_no_mapping': '空のブレット・グラフ',
	'LIVE_bullet_no_mapping_numbered': '空のブレット・グラフ (%{number})',
	'LIVE_bullet_named': '%{name} ブレット・グラフ',
	'LIVE_bullet_named_numbered': '%{name} ブレット・グラフ (%{number})',

	// powered by feature
	'ibmDb2': 'IBM Db2',
	'dashboardPoweredByPrefix': 'このダッシュボード上のデータの提供元',
	'showFooterToggleButtonText': 'フッターの表示',
	'showFooterSectionText': 'フッター'

});
